/* JRC store locator — Leaflet + OpenStreetMap, dealer data inlined by
   snippets/jrc-dealer-data.liquid. No API keys, no third-party app.
   2026-09-23: distributors (snippets/jrc-distributor-data.liquid) are merged
   in with type "distributor" and get their own pin, a badge and the
   Dealers / Distributors toggle (data-jrc-type checkboxes).
   2026-09-24: a distributor's "covers" countries get their own pin (hollow
   square) on that country's capital. The pin, popup and list card read
   exactly like the distributor's own entry (Distributor · territory). */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-jrc-locator]');
    if (!root) return;

    var dataEl = root.querySelector('[data-jrc-dealer-data]');
    var listEl = root.querySelector('[data-jrc-list]');
    var mapEl = root.querySelector('[data-jrc-map]');
    var searchEl = root.querySelector('[data-jrc-search]');
    var countryEl = root.querySelector('[data-jrc-country]');
    var nearEl = root.querySelector('[data-jrc-near]');
    var countEl = root.querySelector('[data-jrc-count]');
    var statusEl = root.querySelector('[data-jrc-status]');
    var typeEls = Array.prototype.slice.call(root.querySelectorAll('[data-jrc-type]'));

    var dealers;
    try {
      dealers = JSON.parse(dataEl.textContent).dealers;
    } catch (e) {
      if (statusEl) statusEl.textContent = 'Sorry — the dealer list could not be loaded. Please contact us and we will point you to your nearest stockist.';
      return;
    }
    /* distributors live in their own snippet (jrc-distributor-data) */
    var distEl = root.querySelector('[data-jrc-distributor-data]');
    if (distEl) {
      try {
        var dists = JSON.parse(distEl.textContent).distributors;
        /* an account that is both a dealer and a distributor (same email, e.g. Freeride) is shown once, as the distributor,
           at the distributor entry's address — the one the orders ship to */
        var distEmails = {};
        dists.forEach(function (d) { if (d.email) distEmails[String(d.email).toLowerCase()] = true; });
        dealers = dealers.filter(function (d) { return !(d.email && distEmails[String(d.email).toLowerCase()]); });
        dists.forEach(function (d) {
          d.type = 'distributor';
          dealers.push(d);
          /* countries the distributor serves from elsewhere (e.g. Austria from Köln) get their own pin on the
             capital, carrying the distributor's details — so the country filter and a "Belgium" search find it */
          (d.covers || []).forEach(function (c) {
            var p = {};
            for (var k in d) if (k !== 'covers' && Object.prototype.hasOwnProperty.call(d, k)) p[k] = d[k];
            p.lat = c.lat; p.lng = c.lng;
            p.homeLat = d.lat; p.homeLng = d.lng;
            p.country = c.country;
            p.homeCountry = d.country;
            p.coverCity = c.city || '';
            p._proxy = true;
            p._homeRef = d;
            dealers.push(p);
          });
        });
      } catch (e) { /* a bad distributor list should not take the dealers down */ }
    }
    dealers.forEach(function (d, i) {
      d._i = i;
      d._dist = null;
      d._type = d.type === 'distributor' ? 'distributor' : 'dealer';
    });
    var isDist = function (d) { return d._type === 'distributor'; };
    var isProxy = function (d) { return !!d._proxy; };
    var nDealers = dealers.filter(function (d) { return !isDist(d); }).length;
    var nDist = dealers.filter(function (d) { return isDist(d) && !isProxy(d); }).length;   /* badge: real distributors */
    typeEls.forEach(function (el) {
      var n = el.value === 'distributor' ? nDist : nDealers;
      var badge = el.parentNode.querySelector('[data-jrc-type-count]');
      if (badge) badge.textContent = n;
      if (!n) el.parentNode.hidden = true;
    });

    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var webHref = function (w) { return /^https?:\/\//i.test(w) ? w : 'https://' + w; };
    var webLabel = function (w) {
      return w.replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/.*$/, '');
    };

    /* ---------- country filter ---------- */
    var counts = {};
    dealers.forEach(function (d) { counts[d.country] = (counts[d.country] || 0) + 1; });
    Object.keys(counts).sort().forEach(function (c) {
      var o = document.createElement('option');
      o.value = c;
      o.textContent = c + ' (' + counts[c] + ')';
      countryEl.appendChild(o);
    });

    /* ---------- map ---------- */
    var map = null;
    var cluster = null;
    var markers = [];
    var userMarker = null;
    var hasLeaflet = typeof window.L !== 'undefined';

    var pinIcon = null;
    var distIcon = null;
    var proxyIcon = null;
    if (hasLeaflet) {
      var pinSvg = function (fill, inner) {
        return '<svg viewBox="0 0 24 34" width="26" height="37" aria-hidden="true"><path d="M12 0C5.4 0 0 5.4 0 12c0 8.4 10.6 20.6 11.1 21.1a1.2 1.2 0 0 0 1.8 0C13.4 32.6 24 20.4 24 12 24 5.4 18.6 0 12 0z" fill="' + fill + '"/>' + inner + '</svg>';
      };
      pinIcon = L.divIcon({
        className: 'jrc-sl-pin',
        html: pinSvg('#121212', '<circle cx="12" cy="12" r="5" fill="#fff"/>'),
        iconSize: [26, 37],
        iconAnchor: [13, 36],
        popupAnchor: [0, -32]
      });
      /* distributors: white pin with a dark square, so they read differently at a glance */
      distIcon = L.divIcon({
        className: 'jrc-sl-pin jrc-sl-pin--dist',
        html: pinSvg('#ffffff', '<path d="M12 0C5.4 0 0 5.4 0 12c0 8.4 10.6 20.6 11.1 21.1a1.2 1.2 0 0 0 1.8 0C13.4 32.6 24 20.4 24 12 24 5.4 18.6 0 12 0z" fill="none" stroke="#121212" stroke-width="1.6"/><rect x="7.5" y="7.5" width="9" height="9" rx="1.5" fill="#121212"/>'),
        iconSize: [26, 37],
        iconAnchor: [13, 36],
        popupAnchor: [0, -32]
      });

      /* covered-country pins: same white pin, hollow square — "served from elsewhere" */
      proxyIcon = L.divIcon({
        className: 'jrc-sl-pin jrc-sl-pin--dist jrc-sl-pin--proxy',
        html: pinSvg('#ffffff', '<path d="M12 0C5.4 0 0 5.4 0 12c0 8.4 10.6 20.6 11.1 21.1a1.2 1.2 0 0 0 1.8 0C13.4 32.6 24 20.4 24 12 24 5.4 18.6 0 12 0z" fill="none" stroke="#121212" stroke-width="1.6"/><rect x="7.75" y="7.75" width="8.5" height="8.5" rx="1.5" fill="none" stroke="#121212" stroke-width="1.8"/>'),
        iconSize: [26, 37],
        iconAnchor: [13, 36],
        popupAnchor: [0, -32]
      });

      map = L.map(mapEl, { scrollWheelZoom: false });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors'
      }).addTo(map);
      /* scroll-wheel zoom only after the map is clicked, so the page scroll is not trapped */
      map.on('click focus', function () { map.scrollWheelZoom.enable(); });
      map.on('mouseout', function () { map.scrollWheelZoom.disable(); });

      var clusterOk = typeof L.markerClusterGroup === 'function';
      cluster = clusterOk
        ? L.markerClusterGroup({
            showCoverageOnHover: false,
            maxClusterRadius: 44,
            iconCreateFunction: function (c) {
              return L.divIcon({
                html: '<span>' + c.getChildCount() + '</span>',
                className: 'jrc-sl-cluster',
                iconSize: [36, 36]
              });
            }
          })
        : L.layerGroup();
      cluster.addTo(map);

      dealers.forEach(function (d) {
        var m = L.marker([d.lat, d.lng], { icon: isProxy(d) ? proxyIcon : (isDist(d) ? distIcon : pinIcon) });
        m.bindPopup(popupHtml(d), { maxWidth: 280 });
        m.on('click', function () { highlightCard(d._i, false); });
        markers[d._i] = m;
      });
    } else {
      mapEl.classList.add('jrc-sl-map--off');
      mapEl.innerHTML = '<p class="jrc-sl-map-fallback">Map unavailable — the full dealer list is below.</p>';
    }

    function popupHtml(d) {
      var lines = [];
      if (isDist(d)) lines.push('<span class="jrc-sl-tag">Distributor' + (d.territory ? ' &middot; ' + esc(d.territory) : '') + '</span>');
      lines.push('<strong class="jrc-sl-pop-name">' + esc(d.name) + '</strong>');
      var addr = [d.addr1, d.addr2, [d.city, d.zip].filter(Boolean).join(' '), [d.state, d.homeCountry || d.country].filter(Boolean).join(', ')]
        .filter(Boolean).map(esc).join('<br>');
      if (addr) lines.push('<span class="jrc-sl-pop-addr">' + addr + '</span>');
      var links = [];
      if (d.phone) links.push('<a href="tel:' + esc(d.phone.replace(/[^+\d]/g, '')) + '">' + esc(d.phone) + '</a>');
      if (d.web) links.push('<a href="' + esc(webHref(d.web)) + '" target="_blank" rel="noopener">' + esc(webLabel(d.web)) + '</a>');
      if (isDist(d) && d.email) links.push('<a href="mailto:' + esc(d.email) + '">' + esc(d.email) + '</a>');
      var dLat = isProxy(d) ? d.homeLat : d.lat, dLng = isProxy(d) ? d.homeLng : d.lng;   /* directions go to the distributor itself */
      links.push('<a href="https://www.google.com/maps/dir/?api=1&destination=' + dLat + ',' + dLng + '" target="_blank" rel="noopener">Directions</a>');
      lines.push('<span class="jrc-sl-pop-links">' + links.join(' &middot; ') + '</span>');
      return '<div class="jrc-sl-pop">' + lines.join('') + '</div>';
    }

    /* ---------- list ---------- */
    function cardHtml(d) {
      var addr = [d.addr1, [d.city, d.zip].filter(Boolean).join(' ')].filter(Boolean).map(esc).join(', ');
      var h = '<button type="button" class="jrc-sl-card' + (isDist(d) ? ' jrc-sl-card--dist' : '') + '" data-jrc-card="' + d._i + '">';
      if (isDist(d)) h += '<span class="jrc-sl-tag">Distributor' + (d.territory ? ' &middot; ' + esc(d.territory) : '') + '</span>';
      h += '<span class="jrc-sl-card-top"><span class="jrc-sl-card-name">' + esc(d.name) + '</span>';
      if (d._dist != null) h += '<span class="jrc-sl-card-dist">' + formatDist(d._dist) + '</span>';
      h += '</span>';
      if (addr) h += '<span class="jrc-sl-card-addr">' + addr + '</span>';
      h += '<span class="jrc-sl-card-country">' + esc(d.homeCountry || d.country) + '</span>';
      h += '</button>';
      return h;
    }
    function formatDist(km) {
      return km < 10 ? km.toFixed(1) + ' km' : Math.round(km) + ' km';
    }

    var current = dealers.slice();
    function render() {
      var q = (searchEl.value || '').trim().toLowerCase();
      var country = countryEl.value;
      var types = {};
      typeEls.forEach(function (el) { types[el.value] = el.checked; });
      var typeOn = function (d) { return typeEls.length ? types[d._type] !== false : true; };
      current = dealers.filter(function (d) {
        if (!typeOn(d)) return false;
        if (country && d.country !== country) return false;
        if (!q) return true;
        return [d.name, d.city, d.country, d.homeCountry, d.zip, d.addr1, d.state, d.territory].join(' ').toLowerCase().indexOf(q) !== -1;
      });
      if (current[0] && current[0]._dist != null) {
        current.sort(function (a, b) { return a._dist - b._dist; });
      }
      /* the list shows each distributor once (its covered-country pins stay on the map) */
      var seen = {};
      var listed = current.filter(function (d) {
        if (!isDist(d)) return true;
        var key = d.name + '|' + (d.email || '');
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
      listEl.innerHTML = listed.length
        ? listed.map(cardHtml).join('')
        : '<p class="jrc-sl-empty">Nothing matches your search.</p>';
      var shownDealers = listed.filter(function (d) { return !isDist(d); }).length;
      var shownDist = listed.length - shownDealers;
      var label = function (n, one, many) { return n + ' ' + (n === 1 ? one : many); };
      countEl.textContent = current.length === dealers.length
        ? label(nDealers, 'store', 'stores') + (nDist ? ' and ' + label(nDist, 'distributor', 'distributors') : '') + ' in ' + Object.keys(counts).length + ' countries'
        : [shownDealers ? label(shownDealers, 'store', 'stores') : '', shownDist ? label(shownDist, 'distributor', 'distributors') : ''].filter(Boolean).join(' and ') || '0 results';

      if (map) {
        cluster.clearLayers();
        current.forEach(function (d) { cluster.addLayer(markers[d._i]); });
        fitTo(current, !q && !country);
      }
    }

    function fitTo(set, unfiltered) {
      if (!map || !set.length) return;
      var pts = set.map(function (d) { return [d.lat, d.lng]; });
      /* On the unfiltered view, frame the region where most dealers are
         (Europe) instead of a near-empty world map. */
      if (unfiltered) {
        var eu = set.filter(function (d) {
          return d.lat > 34 && d.lat < 62 && d.lng > -12 && d.lng < 26;
        });
        if (eu.length >= set.length / 2) pts = eu.map(function (d) { return [d.lat, d.lng]; });
      }
      map.fitBounds(L.latLngBounds(pts).pad(0.06), { maxZoom: 12 });
    }

    function highlightCard(i, scroll) {
      var prev = listEl.querySelector('.jrc-sl-card.is-active');
      if (prev) prev.classList.remove('is-active');
      var card = listEl.querySelector('[data-jrc-card="' + i + '"]');
      /* a covered-country pin highlights its distributor's card when that is the one listed */
      if (!card && dealers[i] && dealers[i]._homeRef) card = listEl.querySelector('[data-jrc-card="' + dealers[i]._homeRef._i + '"]');
      if (card) {
        card.classList.add('is-active');
        if (scroll !== false) card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    listEl.addEventListener('click', function (e) {
      var card = e.target.closest('[data-jrc-card]');
      if (!card) return;
      var i = parseInt(card.getAttribute('data-jrc-card'), 10);
      highlightCard(i, false);
      if (!map) return;
      var m = markers[i];
      if (typeof cluster.zoomToShowLayer === 'function') {
        cluster.zoomToShowLayer(m, function () { m.openPopup(); });
      } else {
        map.setView(m.getLatLng(), 13);
        m.openPopup();
      }
      if (window.matchMedia('(max-width: 989px)').matches) {
        mapEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });

    searchEl.addEventListener('input', render);
    countryEl.addEventListener('change', render);
    typeEls.forEach(function (el) { el.addEventListener('change', render); });

    /* ---------- near me ---------- */
    function haversine(a, b, c, d2) {
      var r = Math.PI / 180, R = 6371;
      var dLat = (c - a) * r, dLng = (d2 - b) * r;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(a * r) * Math.cos(c * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(s));
    }
    nearEl.addEventListener('click', function () {
      if (!navigator.geolocation) {
        statusEl.textContent = 'Location is not available in this browser.';
        return;
      }
      nearEl.disabled = true;
      statusEl.textContent = 'Finding the nearest ones to you…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        nearEl.disabled = false;
        statusEl.textContent = '';
        var lat = pos.coords.latitude, lng = pos.coords.longitude;
        dealers.forEach(function (d) { d._dist = haversine(lat, lng, d.lat, d.lng); });
        countryEl.value = '';
        searchEl.value = '';
        render();
        if (map) {
          if (userMarker) userMarker.remove();
          userMarker = L.marker([lat, lng], {
            icon: L.divIcon({ className: 'jrc-sl-you', html: '<span></span>', iconSize: [18, 18], iconAnchor: [9, 9] }),
            interactive: false
          }).addTo(map);
          var nearest = current.slice(0, 5).map(function (d) { return [d.lat, d.lng]; });
          nearest.push([lat, lng]);
          map.fitBounds(L.latLngBounds(nearest).pad(0.2));
        }
      }, function () {
        nearEl.disabled = false;
        statusEl.textContent = 'We could not get your location — check your browser permissions, or search by town or country instead.';
      }, { timeout: 10000, maximumAge: 300000 });
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
